import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";
import {useSelector} from "react-redux";

export const useKontaPowiazaneProfilu = (profilId, enabled = true) => {
    const rola = useSelector((state) => state.user.role)
    const roleParam = rola === 'oper' ? 'oper/' : ''

    return useQuery({
        queryKey: [`profile_konta_polaczone`, profilId, rola],
        queryFn: () => getData(`${roleParam}profile/${profilId}/polaczone`),
        enabled: enabled && !!profilId,
        refetchOnMount: true,
    })
}
